import {
    setBtnEvent
} from './load.js';
import {
    getMockData
} from './datas/mockdata.js';
import {
    CLAPI
} from './clchart/cl.api.js'

// 用户信息操作
function saveUserInfo(key, value) {
    if (window.localStorage) {
        window.localStorage.setItem(key, value);
    }
}

function loadUserInfo(key) {
    if (window.localStorage) {
        return window.localStorage.getItem(key);
    }
}

function clearUserInfo() {
    if (window.localStorage) {
        window.localStorage.clear();
    }
}

function removeUserInfo(key) {
    if (window.localStorage) {
        window.localStorage.removeItem(key);
    }
}
// systemInfo.userInfo.newKey 变化
function changeKey() {
    // 检查输入是否合法 合法就传入工作层
    if (systemInfo.userInfo.newKey.length > 0) {
        if (systemInfo.userInfo.newKey === "shzs") {
            systemInfo.userInfo.newKey = 'SH000001'
        }
        else if (systemInfo.userInfo.newKey === "szzs") {
            systemInfo.userInfo.newKey = 'SZ399001'
        }
        if (systemInfo.userInfo.newKey.length < 6) {
            systemInfo.userInfo.newKey = systemInfo.userInfo.newKey.padStart(6, "0");
        }
        if (systemInfo.userInfo.newKey.length == 8) {
            changeChart()
        } else {
            // console.log(systemInfo.userInfo.curKey, typeof systemInfo.userInfo.curKey === 'undefined')
            let ch = systemInfo.userInfo.newKey.substring(0, 2)
            if (typeof systemInfo.userInfo.curKey === 'undefined') {
                systemInfo.userInfo.curKey = 'SH600600'
            }
            
            if (ch === "60" || ch === "68") {
                systemInfo.userInfo.newKey = 'SH' + systemInfo.userInfo.newKey
                changeChart()
            }
            if (ch === "00" || ch === "30") {
                systemInfo.userInfo.newKey = 'SZ' + systemInfo.userInfo.newKey
                changeChart()
            }
        }
    } else {
        systemInfo.userInfo.newKey = undefined
    }
}

function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export function getSysChart() {
    return systemInfo.curChart
}

////////////////////////////
//-------- web服务器 ----- //
////////////////////////////
export function showWarnInfo(info) {
    alert(info)
}

export function getcurKey() {
    let curKey = systemInfo.userInfo.curKey
    // console.log(typeof systemInfo.userInfo.newKey, systemInfo.userInfo.newKey, systemInfo.userInfo.curKey)
    if (typeof systemInfo.userInfo.newKey !== 'undefined') {
        curKey = systemInfo.userInfo.newKey
    } else if (typeof systemInfo.userInfo.curKey === 'undefined') {
        systemInfo.userInfo.curKey = 'SH600745' // 找一个默认值
        curKey = systemInfo.userInfo.curKey
    }
    // systemInfo.userInfo.newKey = undefined
    // console.log(typeof systemInfo.userInfo.newKey, systemInfo.userInfo.newKey, systemInfo.userInfo.curKey)
    return curKey
}

export function setcurKey(curKey) {
    systemInfo.userInfo.curKey = curKey;
    systemInfo.userInfo.newKey = undefined
}

export function getUserInfo(kname, key, val) {
    // console.log(kname, key, systemInfo.userInfo[kname]);
    if (systemInfo.userInfo[kname] === undefined) {
        return val
    }
    if (systemInfo.userInfo[kname][key] === undefined) {
        return val
    }
    return systemInfo.userInfo[kname][key]
}
export function setUserInfo(kname, key, val) {
    // console.log(systemInfo.userInfo[kname]);
    if (systemInfo.userInfo[kname] === undefined) {
        systemInfo.userInfo[kname] = {}
    }
    systemInfo.userInfo[kname][key] = val
    console.log(systemInfo.userInfo[kname]);
}

export function checkDatas(datas, ignores) {
    let isok = true;
    for (const name in datas) {
        // console.log(datas[name].tag, datas[name].ignore)
        // if (datas[name].tag !== 0 && !datas[name].ignore) {
        if (datas[name].tag !== 0) {
            console.log(datas)
            if (ignores) {
                if (ignores.includes(name)) {
                    continue
                }
            }
            isok = false;
            break;
            // console.log(isok, datas[name])
        }
    }
    if (!isok) {
        // showWarnInfo('数据没有准备好!')
    }
    return isok;
}

export function strTocsv(instr) {
    if (instr === undefined) {
        return 
    }
    // console.log(instr);
    const lines = instr.trim().split('\n');
  
    // 第一行：字段名
    const fieldsArr = lines[0].split(',');
    const fields = {};
    fieldsArr.forEach((name, index) => {
        fields[name] = index;
    });

    // 数据行
    const datas = lines.slice(1).map(line => {
        return line.split(',').map(item => {
        // 数字自动转数字
        return isNaN(item) ? item : Number(item);
        });
    });
    // console.log(fields, datas);
    return {
        fields,
        datas,
    }
}

const waitInfo = {
    cursec: 500,
    minsec: 500,
    maxsec: 5000,
    steps: 1000
}
// 服务器事件操作
export function connectServer() {
    systemInfo.server.ws = new WebSocket(systemInfo.server.address)
    systemInfo.server.ws.onopen = function (e) {
        systemInfo.server.status = 'opened';
        console.log(systemInfo.server.status);
        sendCommand({
                name: "auth",
                cmds: [{
                    "cmd": "auth",
                    "info": {
                        "username": systemInfo.username,
                        "password": systemInfo.userpass,
                    }
                }]
            },
            function reply(datas) {
                systemInfo.server.status = 'authed';
                if (systemInfo.server.style !== 'mock') {
                    changeChart()
                }
                console.log(systemInfo.server.status);
            })
        waitInfo.cursec = waitInfo.minsec
    };
    systemInfo.server.ws.onclose = function (e) {
        console.log('ws onclose.')
        // let intervalId = setInterval(() => {
        //     console.log('延迟执行的代码...', waitInfo.cursec);
        //     // 清除定时器，确保只执行一次
        //     clearInterval(intervalId);
        //     connectServer();
        //     waitInfo.cursec += waitInfo.steps
        //     if (waitInfo.cursec > waitInfo.maxsec) {
        //         waitInfo.cursec = waitInfo.maxsec
        //     }
        // }, waitInfo.cursec);
        // connectServer();
    };

    systemInfo.server.ws.onerror = function (evt) {
        console.log('ws onerror.', evt);
    };
    systemInfo.server.ws.onmessage = function (message) {

        console.log('===>', typeof message.data, message.data.length);

        if (typeof (message.data) === "string") {
            let start = message.data.indexOf(':');
            let cidx = message.data.substr(0, start);

            if (systemInfo.server.wait.commands[cidx] !== undefined) {
                let data = JSON.parse(message.data.substr(start + 1, message.data.length))

                let repv = systemInfo.server.wait.replys[systemInfo.server.wait.commands[cidx].name]
                if (data.tag !== undefined) {
                    repv['tag'] = data.tag;
                    if (data.tag == 0) {
                        if (isJson(data.info)) {
                            let infoData = JSON.parse(data.info)
                            if (infoData.datas === undefined) {
                                repv['infos'] = infoData
                            }
                            else {
                                repv['datas'] = infoData.datas
                                repv['fields'] = infoData.fields
                            }
                            // console.log(typeof infoData, infoData.datas);
                        }
                        else {
                            // 试着去转csv
                            let infoData = strTocsv(data.info)
                            if (infoData) {
                                repv['datas'] = infoData.datas
                                repv['fields'] = infoData.fields
                            }
                        }
                    } else {
                        console.log(cidx, data.info)
                        repv['info'] = data.info
                    }
                } else {
                    repv['tag'] = -1
                    repv['info'] = 'ERROR';
                }
                setCatchkData(systemInfo.server.wait.commands[cidx], repv)
            }
            replyCommand()
        }
    }
    systemInfo.server.status = 'connect'
    console.log(systemInfo.server.status)
};
export function checkServer() {
    if (systemInfo.server.status === 'connect') {
        return true
    }
    return false
};

let cmdID = 0;

function getCmdID() {
    cmdID++
    return cmdID.toString();
}

function replyCommand() {
    let whole = true;
    for (const cidx in systemInfo.server.wait.commands) {

        if (systemInfo.server.wait.replys[systemInfo.server.wait.commands[cidx].name].tag === undefined) {
            whole = false;
            break;
        }
    }
    if (whole) {
        // let infoData = {}
        // if (isJson(datas[0])) {
        //     infoData = JSON.parse(datas[0])         
        // }
        // let dateData = {}
        // if (isJson(datas[0])) {
        //     dateData = JSON.parse(datas[1])         
        // }
        systemInfo.server.wait.callback(systemInfo.server.wait.replys);
    }
}

function setCatchkData(askinfo, repv) {
    if (repv.tag !== 0) {
        return
    }
    const hashkey = CLAPI.Utils.getHashStr(askinfo.info)
    const nowmsec = CLAPI.Utils.getNowMsec()
    systemInfo.catchs[hashkey] = {
        nowmsec,
        tag: 0,
        fields: repv.fields,
        datas: repv.datas,
        infos: repv.infos,
    }
    // console.log('set', hashkey, systemInfo.catchs[hashkey])
}
// 找到缓存数据
function getCatchkData(askinfo) {
    const hashkey = CLAPI.Utils.getHashStr(askinfo.info)
    const nowmsec = CLAPI.Utils.getNowMsec()
    const nowminu = CLAPI.Utils.getMsecMinu(nowmsec)
    if (systemInfo.catchs[hashkey] !== undefined) {
        console.log('get', hashkey, askinfo);
        // if (((nowmsec - systemInfo.catchs[hashkey].nowmsec) < 5000) && nowminu >= 900 && nowminu < 1530) {
        //     return false
        // }
        systemInfo.server.wait.replys[askinfo.name] = {
            tag: 0,
            fields: systemInfo.catchs[hashkey].fields,
            datas: systemInfo.catchs[hashkey].datas,
            infos: systemInfo.catchs[hashkey].infos,
        }
        return true
    }
    return false;
}

// 多个命令组合 当发出的指令全部返回后，就回调函数
// 后续通过 getHashStr 对发出的请求数据做时间缓存 缓存有的数据且时间存活 就直接返回数据
export function sendCommand(askcmds, callback) {
    if (systemInfo.server.style === 'mock') {
        callback(getMockData(askcmds.cmds, systemInfo.userInfo.curKey));
        return
    }
    systemInfo.server.wait = {
        callback: callback,
        commands: {},
        replys: {}
    }
    const commands = systemInfo.server.wait.commands
    for (const askname in askcmds.cmds) {
        const cidx = getCmdID()
        commands[cidx] = {
            name: askname,
            info: JSON.stringify(askcmds.cmds[askname])
        }
        systemInfo.server.wait.replys[askname] = {}
    }
    for (const cidx in commands) {
        if (!getCatchkData(commands[cidx])) {
            let sendstr = cidx + ':' + commands[cidx].info
            console.log('<===', sendstr, commands[cidx].name);
            systemInfo.server.ws.send(sendstr);
        } else {
            replyCommand()
        }
    }

}

export function isJson(str) {
    if (typeof str == 'string') {
        try {
            let obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            // console.log('error : ' + str + '!!!' + e);
            return false;
        }
    }
    // console.log('It is not a string!')
}
////////////////////////////
//-------- 初始化事件 ----- //
////////////////////////////
function nextChart() {
    // 这里判断是否切换画面
    
    const whileCharts = systemInfo.whileCharts
    if (systemInfo.userInfo.rootChart === undefined) {
        systemInfo.userInfo.rootChart = systemInfo.userInfo.activeChart
    }
    const curCharts = whileCharts[systemInfo.userInfo.rootChart]
    console.log(curCharts, systemInfo.userInfo.rootChart, systemInfo.userInfo.activeChart);
    if (curCharts !== undefined) {
        if (systemInfo.userInfo.activeChart === systemInfo.userInfo.rootChart) {
            changeChart(curCharts[0])
            return
        }
        for (let index = 0; index < curCharts.length; index++) {
            if (curCharts[index] === systemInfo.userInfo.activeChart) {
                if (index === curCharts.length - 1) {
                    changeChart(systemInfo.userInfo.rootChart)
                    return
                }
                else {
                    changeChart(curCharts[index + 1])
                    return
                }
            }
        }
        // changeChart(systemInfo.userInfo.rootChart)
    }
    // console.log(systemInfo.userInfo.activeChart, whileCharts[systemInfo.userInfo.activeChart]);
}

function setWinEvent() {
    function resetSize() {
        {
            let canvas = systemInfo.initInfo.mainCanvas.canvas
            canvas.width = canvas.clientWidth * window.devicePixelRatio
            canvas.height = canvas.clientHeight * window.devicePixelRatio
        } {
            let canvas = systemInfo.initInfo.moveCanvas.canvas
            canvas.width = canvas.clientWidth * window.devicePixelRatio
            canvas.height = canvas.clientHeight * window.devicePixelRatio
        } {
            let canvas = systemInfo.initInfo.swimCanvas.canvas
            canvas.width = canvas.clientWidth * window.devicePixelRatio
            canvas.height = canvas.clientHeight * window.devicePixelRatio
        }
        if (typeof systemInfo.curChart !== 'undefined') {
            systemInfo.curChart.scale = window.devicePixelRatio
        }
        scale = systemInfo.curChart.scale
    }    
    /////////
    // 这个事件在 load 之前发生 此时加载插件数据
    document.addEventListener("DOMContentLoaded", function () {
        // console.log("====", location.hostname);
        const device = getDeviceType()
        const headmenu = document.getElementById('chart-menu');
        
        // console.log(device, headmenu);
        if (device !== 'mobile') {
            headmenu.classList.add('pcshow')
        }
        else {
            headmenu.classList.remove('pcshow')
        }
        
    });
    window.addEventListener('load', function () {
        resetSize()
        // console.log('onresize', window.devicePixelRatio, systemInfo.curChart.scale, systemInfo.curChart);
        if (systemInfo.server.style === 'mock') {
            changeChart()
        }
    });
    window.addEventListener('wheel', function (event) {
        // 判断是否为左移手势
        // console.log('浏览器导航按钮被点击了，当前页面状态:', window.history, event.state);
        if (event.deltaX !== 0) {
            // 阻止默认行为
            event.preventDefault();
        }
    }, { passive: false });
    // 监听popstate事件
    // window.history = []
    window.addEventListener('popstate', function (event) {
        event.preventDefault();
        history.pushState(null, null, location.href);
        console.log('浏览器导航按钮被点击了，当前页面状态:', window.history, event);
        // 只有通过菜单才可以确定循环方法的主索引
        // systemInfo.userInfo.rootChart = 
        // 在这里可以根据具体需求执行相应的逻辑，比如重新加载页面部分内容、更新页面显示等
    }, { passive: false });
    // 可以手动添加历史记录状态，模拟页面间的切换（可选操作）
    // history.pushState({ page: 1 }, 'Page 1', 'page1.html');
    // history.pushState({ page: 2 }, 'Page 2', 'page2.html');


    // 监听 touchmove 事件（针对触摸屏设备）
    window.addEventListener('touchmove', function (event) {
        e.preventDefault();
        // if (event.touches.length !== 0) {
        //     const touch = event.touches[0];
        //     if (typeof this.initialX === 'undefined') {
        //         this.initialX = touch.pageX;
        //     }
        //     const currentX = touch.pageX;
        //     const diffX = currentX - this.initialX;
        //     if (diffX < 0) {
        //         // 左移手势，阻止默认行为
        //         event.preventDefault();
        //     }
        //     this.initialX = currentX;
        // }
    }, {
        passive: false
    });
    // 以下事件在离开或刷新页面时触发
    window.addEventListener("beforeunload", function (event) {
        // 这里保存参数 
        saveUserInfo('userInfo', JSON.stringify(systemInfo.userInfo));
        // event.preventDefault();
        // event.returnValue = '确定要离开吗？'
    });
    // 处理窗口尺寸变化
    window.onresize = window._debounce(function () {
        console.log('onresize', window.devicePixelRatio, systemInfo.curChart.scale);
        
        resetSize()
        if (typeof systemInfo.curChart !== 'undefined') {
            // systemInfo.curChart.onPaint()
            changeChart()
        }
    }, 100)
    // 接受外部输入
    var inputBox = document.getElementById('inputBox');
    document.addEventListener('keydown', function (event) {
        // 激活输入框
        // console.log(event, event.key, event.keyCode)
        if ((event.key >= '0' && event.key <= '9') || 
            event.key == 's' || event.key == 'z' || event.key == 'h') {
            inputBox.focus();
        }
        if (document.activeElement === inputBox) {
            if (event.key === 'Enter') {
                console.log('Enter 键被按下了');
                if (inputBox.value.length > 0) {
                    inputBox.focus();
                    systemInfo.userInfo.newKey = inputBox.value; // 只有当数据成功才会设置到 curKey 否则设置为 ''
                    changeKey()
                    inputBox.value = '';
                    inputBox.blur(); // 取消焦点
                }
            }
        } else {
            if (event.key === 'Enter') {
                nextChart()
            } else {
                // 这里强制传递一下按键事件 鼠标事件下层可以自动获取
                const keydownEvent = new KeyboardEvent('keydown', {
                    key: event.key,
                    code: event.code,
                    keyCode: event.keyCode
                });
                systemInfo.initInfo.eventCanvas.dispatchEvent(keydownEvent);
            }
        }
    });
}
export function sendKeydownEvent(event) {
    const keydownEvent = new KeyboardEvent('keydown', {
        key: event.key,
        code: event.code,
        keyCode: event.keyCode
    });
    document.dispatchEvent(keydownEvent);
}
function setNavigation() {
    systemInfo.backBtn.disabled = systemInfo.navigation.index == 0
    systemInfo.forwardBtn.disabled = systemInfo.navigation.index == systemInfo.navigation.names.length - 1

}
function incrNavigation(mName) {
    const curKey = getcurKey()
    // console.log(systemInfo.navigation, curKey, systemInfo.userInfo.newKey);
    if (systemInfo.navigation.names.length > 0) {
        const curName = systemInfo.navigation.names.at(-1)
        console.log(systemInfo.navigation, curName, curName.curKey, curKey, systemInfo.userInfo.newKey);
        if (curName.classname !== mName || curName.curKey !== curKey ||
            (systemInfo.userInfo.newKey !== undefined && systemInfo.userInfo.newKey !== curKey)
        ) {
            systemInfo.navigation.names.push({classname : mName, curKey : curKey})
        }
        else {
            return
        }
    } else {
        systemInfo.navigation.names.push({classname : mName, curKey : curKey})
    }
    if (systemInfo.navigation.names.length > 10) {
        systemInfo.navigation.names.shift()
    }
    // console.log(systemInfo.navigation);
    systemInfo.navigation.index = systemInfo.navigation.names.length - 1
    setNavigation()
}
function initNavigation(systemInfo) {
    systemInfo.backBtn = document.getElementById('back-button');
    systemInfo.forwardBtn = document.getElementById('forward-button');
    systemInfo.backBtn.addEventListener('click', function () {
        const navigation = systemInfo.navigation
        console.log(navigation);
        if (navigation.index < 0) {
            navigation.index = navigation.names.length - 1
        }
        if (navigation.index > 0) {
            if (navigation.names[navigation.index - 1].curKey !== undefined) {
                setcurKey(navigation.names[navigation.index - 1].curKey)
            }
            changeChart(navigation.names[navigation.index - 1].classname, true)
            navigation.index--;
        } 
        setNavigation();
    });
    systemInfo.forwardBtn.addEventListener('click', function () {
        const navigation = systemInfo.navigation
        console.log(navigation);
        if (navigation.index < 0) {
            navigation.index = navigation.names.length - 1
        }
        if (navigation.index < navigation.names.length - 1) {
            if (navigation.names[navigation.index + 1].curKey !== undefined) {
                setcurKey(navigation.names[navigation.index + 1].curKey)
            }
            changeChart(navigation.names[navigation.index + 1].classname, true)
            navigation.index++;
        }
        setNavigation();
    });
}

function getDeviceType() {
  const ua = navigator.userAgent.toLowerCase();
//   return 'xx'
  // iPad / 平板
  if (/(ipad|android|tablet)/.test(ua) && !/(mobile)/.test(ua)) {
    return "pad";
  }
  
  // 手机
  if (/(iphone|ipod|android.*mobile|windows phone)/.test(ua)) {
    return "mobile";
  }
  
  if (location.hostname.includes('127.0.0.1') || location.hostname.includes('mb.seerline.com')) {
    return "mobile";
  }
  // 电脑
  return "pc";
}

export async function changeChart(mName, navigation) {
    // console.log('===+++===', mName, systemInfo.userInfo.activeChart, systemInfo.userInfo.newKey, navigation)
    if (mName === undefined) {
        if (systemInfo.userInfo['activeChart'] !== undefined) {
            mName = systemInfo.userInfo.activeChart
        } else {
            mName = 'btKbar'
        }
    }
    // console.log(mName, typeof mName, systemInfo.methods, Object.keys(systemInfo.methods), Object.getOwnPropertyNames(systemInfo.methods), 'kbar' in systemInfo.methods)
    if (mName in systemInfo.methods) {
        systemInfo.userInfo.activeChart = mName
        systemInfo.methods[mName].method(systemInfo.methods[mName].argvs)
        if (navigation === undefined) {
            incrNavigation(mName)
        }
    }
    // try {
    //     systemInfo.methods[mName]()
    // } catch (e) {
    //     console.log('no method ' + mName + '   :' + e);
    // }
}

function initSystem() {
    const hostname = location.hostname
    systemInfo.remote = 0
    if (!hostname.includes('localhost')) {
        // console.log = () => {}
        let menu = document.querySelectorAll(".col_1");
        // console.log(menu);
        menu.forEach(item=>{
            // console.log(item);
            item.style.code = "#999"
            item.style.pointerEvents = "none"
            item.style.opacity = "0.6"
            item.style.cursor = "not-allowed"
        })
        systemInfo.remote = 1
    }
    systemInfo.device = getDeviceType()
    console.log(systemInfo.device);

}

// ////////////////////////////
// 所有初始化变量都在这里
// systemInfo 为唯一全局变量
// systemInfo.userInfo 为需要保存的数据 kv 结构
// systemInfo.server 为连接服务器的句柄
// ////////////////////////////

//-------- 初始化开始 ----- //
export const systemInfo = {
    methods: {},
    server: {},
    username: 'guest',
    userpass: 'guest1234',
    userInfo: {},
    catchs: {}, // 保存临时数据
    navigation: {
        names: [],
        index: -1
    }, // 导航信息 最多7个
    initInfo: {
        mainCanvas: {
            canvas: document.getElementById('mainChart')
        },
        moveCanvas: {
            canvas: document.getElementById('moveChart')
        },
        swimCanvas: {
            canvas: document.getElementById('swimChart')
        },
        eventCanvas: document.getElementById('swimChart'),
        scale: window.devicePixelRatio,
        axisPlatform: 'web'
    }    
}

// console.log(systemInfo.initInfo);

export let scale = systemInfo.initInfo.scale
export const canvas = systemInfo.initInfo.mainCanvas.canvas

// var serverAddress = 'ws://' + location.hostname + ':7331'
var serverAddress = 'ws://' + location.hostname + ':7329'

console.log("server: ", serverAddress);

// systemInfo.server.style = 'mock' 
systemInfo.server.style = 'ws'

async function startSystem() {
    // 设置事件和菜单
    initSystem()
    // 这里创建画图类
    systemInfo.curChart = new CLAPI.manageChart(systemInfo.initInfo)
    // 设置接受事件的cancas
    // systemInfo.initInfo.eventCanvas = systemInfo.initInfo.moveCanvas.canvas
    // 设置事件
    setWinEvent()
    
    setBtnEvent(systemInfo)

    initNavigation(systemInfo)

    // 加载用户配置
    let cfg = loadUserInfo('userInfo')
    if (isJson(cfg)) {
        systemInfo.userInfo = JSON.parse(cfg)
    } else {
        systemInfo.userInfo = {}
    }
    if (systemInfo.remote) {
        if (systemInfo.device === 'mobile') {
            systemInfo.userInfo.activeChart = 'miAdjust_phone'
        }
    }
    // console.log('userInfo', cfg)
    console.log('userInfo', systemInfo.remote, systemInfo.userInfo)
    
    // 启动服务器
    systemInfo.server.address = serverAddress;
    if (systemInfo.server.style !== 'mock') {
        connectServer();
    }
}

// 这里直接执行
startSystem()